import React, { useState, useEffect } from "react";
import ContactBg from "../assests/contactBg.png";
import Footer from "./Footer";
import prelorder from "../assests/loadingIcon.png";
import Logo from "../assests/mediLogo.png";
import { Link, NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
// Import Swiper styles
import "swiper/css/effect-flip";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import BannerImg from "../assests/bannerImg.jpg";
import axios from "axios";
import { baseUrl } from "./Api/BaseUrl";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGooglePlusG,
  FaYoutube,
} from "react-icons/fa";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
// Localization data
const headerTranslations = {
  1: {
    news: "News",
    agency: "Agency",
    services: "Services",
    work: "Work",
    team: "Team",
    contact: "Contact Us",
    ourservices: "Our Services",
    joinus: "Join Us",
    email: "Email",
    address: "Address",
    gettouch: "Get in Touch with us",
    howcan: "HOW CAN HELP YOU?",
    entername: "Enter Your Name*",
    enteremail: "Enter Email Address*",
    entermessage: "Enter Your Message",
    formtext:
      "We are committed to protecting your privacy. We will never collect information about you without your explicit consent.",
  },
  2: {
    news: "Nouvelles",
    agency: "Agence",
    services: "Services",
    work: "Travail",
    team: "Équipe",
    contact: "Contactez",
    joinus: "Rejoignez-nous",
    ourservices: "Nos prestations",
    email: "e-mail",
    address: "Adresse",
    gettouch: "Contactez-nous",
    howcan: "COMMENT PEUT VOUS AIDER ?",
    entername: "Entrez votre nom*",
    enteremail: "Entrez l'adresse e-mail*",
    entermessage: "Entrez votre message",
    formtext:
      "Nous nous engageons à protéger votre vie privée. Nous ne collecterons jamais d'informations vous concernant sans votre consentement explicite.",
  },
  3: {
    news: "الأخبار",
    agency: "وكالة",
    services: "الخدمات",
    work: "العمل",
    team: "الفريق",
    contact: "اتصل بنا",
    joinus: "انضم إلينا",
    ourservices: "خدماتنا",
    email: "بريد إلكتروني",
    address: "عنوان",
    gettouch: "تواصل معنا",
    howcan: "كيف يمكن أن تساعدك؟",
    entername: "أدخل اسمك*",
    enteremail: "أدخل عنوان البريد الإلكتروني*",
    entermessage: "أدخل رسالتك",
    formtext:
      "نحن ملتزمون بحماية خصوصيتك. لن نقوم أبدًا بجمع معلومات عنك دون موافقتك الصريحة.",
  },
};

const ContactUs = () => {
  // ------Header Code Start Here-------
  const [isOverflow, setIsOverflow] = useState(false);
  const [Active, setActive] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [language, setLanguage] = useState(1);
  const [footerData, setFooterData] = useState(null);

  // Search toggle
  const toggleSearch = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const searchQuery = e.target.elements.q.value;
    console.log("Search query:", searchQuery);
  };

  // ToogleControl Method
  const handleToggleClick = () => {
    if (Active) {
      setIsOverflow(!isOverflow);
      setActive(false);
      setTimeout(() => {
        document.querySelector(".all-cases").style.transitionDelay = "0.5s";
        document.querySelector(".all-cases .layer").style.transitionDelay =
          "0.3s";
        document.querySelector(".all-cases .inner").style.transitionDelay =
          "0s";
      }, 0);
    } else {
      setActive(true);
      setIsOverflow(!isOverflow);
      setTimeout(() => {
        document.querySelector(".all-cases.active").style.transitionDelay =
          "0s";
        document.querySelector(
          ".all-cases.active .layer"
        ).style.transitionDelay = "0.2s";
        document.querySelector(
          ".all-cases.active .inner"
        ).style.transitionDelay = "0.7s";
      }, 0);
    }
  };

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_footer_section`, {
          language: language,
        });
        setFooterData(response.data.Details);
      } catch (error) {
        console.error("Error fetching the Footer Data:", error);
      }
    };
    fetchFooter();
  }, [language]);

  // ------Header Code End Here-------

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    comment: "",
    cv: null, // CV will be a file
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle file (CV) upload change
  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      cv: e.target.files[0],
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("message", formData.comment);
    data.append("cv", formData.cv);

    try {
      const response = await axios.post(`${baseUrl}Join_us_page`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        alert("Form submitted successfully!");
        setFormData({ name: "", email: "", comment: "", cv:"" });
      } else {
        alert("Failed to submit form.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred during submission.");
    }
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      setLanguage(Number(savedLanguage));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const handleLanguage = (e) => {
    e.preventDefault();
    setLanguage(Number(e.target.value));
  };

  // Validation Schema
  const ContactSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, "Name is too short!")
      .max(50, "Name is too Long!")
      .required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is Required"),
    cv: Yup.string().required("CV is required"),
    comment: Yup.string()
      .min(10, "Message must be at least 10 characters")
      .required("Message is required"),
  });
  return (
    <>
      {/* Header & Banner Section Start */}
      <div>
        <div className="preloader">
          <div className="layer"></div>
          <div className="inner">
            <figure>
              <img src={prelorder} alt="Img" />
            </figure>
            <span>The Art of Contact and the Science of Data</span>
          </div>
        </div>

        <div className={`all-cases ${Active ? "active" : ""}`}>
          <div className="layer"> </div>
          <aside className="left-side left-side2">
            <div className="follow-us">FOLLOW US</div>
            <ul>
              <li>
                <Link to="#">
                  <i className="fab fa-facebook-f"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-twitter"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-linkedin-in"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-google-plus-g"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-youtube"></i>
                </Link>
              </li>
            </ul>
            <div className="equalizer">
              <span></span> <span></span> <span></span> <span></span>
            </div>
          </aside>
          <div className="inner">
            <ul>
              <li>
                <NavLink
                  to="/news"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.news}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/agency"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.agency}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/services"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.services}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/work"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.work}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/team"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.team}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.contact}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        <main>
          <div>
            <div className="main_header">
              <div
                className="completeMenu"
                style={{
                  background: "black",
                }}
              >
                <div className="logo">
                  <Link to="/">
                    <img src={Logo} alt="Img" />
                  </Link>
                </div>
                <div className="all-cases-link">
                  <span className="">
                    <div className="nav-open_main d-flex">
                      <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
                        <NavLink
                          to="/news"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.news}
                        </NavLink>
                        <NavLink
                          to="/agency"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.agency}
                        </NavLink>
                        <NavLink
                          to="/services"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.services}
                        </NavLink>
                        <NavLink
                          to="/work"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.work}
                        </NavLink>
                        <NavLink
                          to="/team"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.team}
                        </NavLink>
                        <NavLink
                          to="/contact"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.contact}
                        </NavLink>
                      </nav>
                      <div className="d-flex nav-open_main1">
                        <div className="language-switching">
                          <select value={language} onChange={handleLanguage}>
                            <option value={1}>ENG</option>
                            <option value={2}>FRE</option>
                            <option value={3}>عربي</option>
                          </select>
                        </div>
                        <div className="searching-toggle mx-0">
                          <div
                            className={`search-toggle ${
                              isSearchOpen ? "opened" : "closed"
                            }`}
                          >
                            <button
                              className="search-icon icon-search"
                              onClick={toggleSearch}
                            >
                              <i className="fa fa-fw fa-search"></i>
                            </button>
                            <button
                              className="search-icon icon-close"
                              onClick={toggleSearch}
                              style={{
                                display: isSearchOpen ? "inline-block" : "none",
                              }}
                            >
                              <i className="fa fa-fw fa-close"></i>
                            </button>
                          </div>

                          <div
                            className={`search-container d-flex ${
                              isSearchOpen ? "opened" : "closed"
                            }`}
                            style={{ display: isSearchOpen ? "block" : "none" }}
                          >
                            <form onSubmit={handleSearch}>
                              <input
                                type="text"
                                name="q"
                                id="search-terms"
                                placeholder="Search terms..."
                                autoFocus={isSearchOpen}
                              />
                              <button
                                type="submit"
                                name="submit"
                                value="Go"
                                className="search-icon"
                              >
                                <i className="fa fa-fw fa-search"></i>
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                  <b onClick={handleToggleClick}>
                    <i className={`fa ${Active ? "fa-solid" : "fa-bars"}`}></i>
                  </b>
                </div>
              </div>
            </div>
            <aside className="left-side">
              <div className="follow-us">FOLLOW US</div>
              <ul>
                <li>
                  <Link to="#">
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-linkedin-in"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-google-plus-g"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-youtube"></i>
                  </Link>
                </li>
              </ul>
              <div className="equalizer">
                <span></span> <span></span> <span></span> <span></span>
              </div>
            </aside>
            <div
              className={`body-content ${isOverflow ? "overflow" : ""}`}
            ></div>
          </div>

          <header className="sliderImg">
            <div className="swiper-container gallery-top">
              <div className="BannerImg">
                <img src={BannerImg} alt="BannerImage" />
              </div>
            </div>
            <div className="swiper-container gallery-thumbs">
              <Swiper
                spaceBetween={0}
                slidesPerView={3}
                autoplay={{
                  delay: 9900,
                  disableOnInteraction: false,
                }}
                freeMode
                watchSlidesProgress
                centeredSlides={true}
                touchRatio={0.2}
                slideToClickedSlide={true}
                loop={true}
                loopedSlides={3}
                modules={[Autoplay]}
                breakpoints={{
                  1024: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 1,
                  },
                  640: {
                    slidesPerView: 1,
                  },
                  320: {
                    slidesPerView: 1,
                  },
                }}
                className="swiper-wrapper"
              >
                <SwiperSlide className="swiper-slide">
                  <p>{headerTranslations[language]?.joinus}</p>
                </SwiperSlide>
              </Swiper>
            </div>
          </header>
        </main>
      </div>
      {/* Header & Banner Section End */}

      {/* Contact form Data */}
      <section className="contactForm_data">
        <div className="container-fluid overflow-hidden position-relative">
          <img
            className="position-absolute z-index-minus-1"
            src={ContactBg}
            alt="contactBackImg"
            style={{ display: "none", visibility: "hidden" }}
          />
          <div className="row justify-content-center mb-2">
            <div className="col-lg-6 text-center">
              <span className="text-uppercase text-base-color d-inline-block formText_content">
                {headerTranslations[language]?.gettouch}
              </span>
              <h3 className="text-dark-gray formText_heading">
                {headerTranslations[language]?.howcan}
              </h3>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xxl-6 col-xl-7 col-lg-11">
              <form onSubmit={handleSubmit} className="contact-form-style-03">
                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <label className="form-label text-dark-gray mb-0">
                      {headerTranslations[language]?.entername}
                    </label>
                    <div className="position-relative form-group">
                      <span className="form-icon">
                        <i className="bi bi-emoji-smile"></i>
                      </span>
                      <input
                        className="border-color-extra-medium-gray form-control required"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter your name"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-600 text-dark-gray mb-0">
                      {headerTranslations[language]?.enteremail}
                    </label>
                    <div className="position-relative form-group mb-25px">
                      <span className="form-icon">
                        <i className="bi bi-envelope"></i>
                      </span>
                      <input
                        className="border-color-extra-medium-gray form-control required"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter your email address"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12 mb-4">
                    <label className="form-label text-dark-gray mb-0">
                      {headerTranslations[language]?.entermessage}
                    </label>
                    <div className="position-relative form-group form-textarea mb-0">
                      <textarea
                        className="form-control"
                        name="comment"
                        value={formData.comment}
                        onChange={handleChange}
                        placeholder="Describe your project"
                        rows="3"
                        required
                      ></textarea>

                      <span className="form-icon">
                        <i className="bi bi-chat-square-dots"></i>
                      </span>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="cv-upload-container">
                      <label htmlFor="cv-upload" className="cv-upload-btn">
                        <i className="fas fa-cloud-upload-alt"></i>
                        {formData.cv ? (
                          <span>{formData.cv.name}</span>
                        ) : (
                          "Add your CV"
                        )}
                        <input
                          type="file"
                          name="cv"
                          id="cv-upload"
                          accept=".pdf, .doc, .docx"
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="col-xxl-6 col-lg-7 col-md-8">
                    <p className="formText_paragraph">
                      {headerTranslations[language]?.formtext}
                    </p>
                  </div>
                  <div className="col-xxl-6 col-lg-5 col-md-4 text-center text-md-end">
                    <button className="submitBtn submit" type="submit">
                      Send message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <div className="logoFooter_content">
                <div className="footer_logo">
                  <img src={Logo} alt="footer logo" />
                </div>
                <div className="footer_content">
                  {footerData ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: footerData.description
                          .replace(/\r\n/g, "<br/>")
                          .replace(/\n/g, "<br/>"),
                      }}
                    />
                  ) : (
                    <p>Loading Api Data...</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="navigation-footer">
                <h4>{headerTranslations[language]?.ourservices}</h4>
                <ul>
                  <li>
                    <Link to="/news">{headerTranslations[language]?.news}</Link>
                  </li>
                  <li>
                    <Link to="/agency">
                      {headerTranslations[language]?.agency}
                    </Link>
                  </li>
                  <li>
                    <Link to="/service">
                      {headerTranslations[language]?.services}
                    </Link>
                  </li>
                  <li>
                    <Link to="/work">{headerTranslations[language]?.work}</Link>
                  </li>
                  <li>
                    <Link to="/team">{headerTranslations[language]?.team}</Link>
                  </li>
                  <li>
                    <Link to="/contact"></Link>
                    {headerTranslations[language]?.contact}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footerContact_info">
                <h4>{headerTranslations[language]?.contact}</h4>
              </div>
              <div className="footerContact_data">
                <ul>
                  <li>{headerTranslations[language]?.contact}:- +9645689866</li>
                  <li>
                    {headerTranslations[language]?.email}:- info@medialgeria.com
                  </li>
                  <li>
                    {headerTranslations[language]?.address}:- 16122 Collins
                    Street, Melbourne, Australia
                  </li>
                </ul>
              </div>
              {/* <Link to="/contact" className="link">
                Get in touch
              </Link> */}
              <ul className="my-4 social">
                <li>
                  <Link
                    to="https://www.facebook.com/medialgeria/"
                    target="_blank"
                  >
                    <FaFacebookF />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaTwitter />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFLIm8hcMZygAAAAZG8qETwur3Uzvotg1uL5nQzzNIUTZR-X5fqW-nzhAu8LcBV1Tt4KamACgeaXdCmL3ypUUsKR0tNO1jdyL5JW5y05ftYOC8Mc2XWQdSaAlhRGzFdQTLhbEw=&original_referer=&sessionRedirect=https%3A%2F%2Ffr.linkedin.com%2Fcompany%2Fmedialgeria"
                    target="_blank"
                  >
                    <FaLinkedinIn />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaGooglePlusG />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.youtube.com/channel/UCDjQDI9xZ_qh2AW8ohoZRjw"
                    target="_blank"
                  >
                    <FaYoutube />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-12">
              <div className="footer-bar">
                <span className="copyright">
                  © 2024 Medialgeria | All Rights Reserved
                </span>
                <span className="creation">
                  Site created by
                  <Link to="https://www.webnmobappssolutions.com/">
                    webnmobapps solutions Pvt. Ltd
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default ContactUs;
